import { useState } from 'react';
import { Box, Flex, HStack } from '@chakra-ui/react';
import { useToast, useUpdateProduct } from 'hooks';
import { Modal, ModalBody, Button } from 'components/UI';
import ProductField from '../ProductField';
import ProductSection from '../ProductSection';
import { IProductResource } from '../../../../server/types';

type UpdateVersionProps = {
  productId: string;
  displayName: string;
  onChange: (name: string, value: string) => void;
  data: `Autodesk.Inventor+${27 | 28 | 29 | 30}`;
  onCancelUploadClick: (arg0?: IProductResource) => void;
};

const UpdateVersion = ({ productId, displayName, onChange, data, onCancelUploadClick }: UpdateVersionProps) => {
  const [errorMessage, setErrorMessage] = useState<string | Record<string, never> | null>();
  const [updateProduct] = useUpdateProduct();
  const [showToast] = useToast();

  const onSave = async () => {
    setErrorMessage(null);

    const regex = /^Autodesk.Inventor\+((2[7-9])|30)$/;
    if (data.match(regex)) {
      try {
        const body = { version: data };
        const updatedProduct = await updateProduct(productId, body);
        onCancelUploadClick(updatedProduct as IProductResource);
        showToast({
          status: 'success',
          message: 'Autodesk Engine Version updated successfully!',
        });
      } catch (error) {
        setErrorMessage(error as string);
      }
    } else {
      showToast({
        status: 'error',
        message: 'Autodesk Engine Version is not valid!',
      });
    }
  };

  const renderErrorMessage = errorMessage ? <Box color="red">{errorMessage as string}</Box> : null;

  return (
    <Modal
      isOpen
      isCloseButton
      closeOnEsc={false}
      closeOnOverlayClick
      isCentered
      size="md"
      onClose={() => onCancelUploadClick()}
    >
      <ModalBody pt={6}>
        <Flex flexDir="column">
          <ProductSection name="UPDATE AUTODESK ENGINE">
            {' '}
            <Box>
              <Flex
                sx={{
                  flex: 1,
                  flexDir: 'column',
                  justifyContent: 'column',
                  bgColor: 'base2Colour.500',
                  m: 1.5,
                  alignItems: 'space-between',
                  fontSize: 'sm',
                  color: 'base2FontColour.500',
                }}
              >
                <ProductField
                  name="version"
                  displayName={displayName}
                  edit
                  fieldType="select"
                  onChange={onChange}
                  data={data as string}
                />
              </Flex>
            </Box>
          </ProductSection>
        </Flex>
        <HStack
          sx={{
            justifyContent: 'center',
            gap: 2,
            mt: 1,
            mb: 2,
          }}
        >
          <Button size="sm" disabled={false} onClick={onSave}>
            SAVE
          </Button>
          <Button size="sm" onClick={() => onCancelUploadClick()}>
            CANCEL
          </Button>
        </HStack>

        {renderErrorMessage}
      </ModalBody>
    </Modal>
  );
};

export default UpdateVersion;
